import Users from "../../components/Users";
function UsersPage() {
  return (
    <div>
      <Users />
    </div>
  );
}

export default UsersPage;
